import { InjectionToken } from '@angular/core';

import { Task, TaskType } from '../models/task.interface';

export interface TaskActionHandler<T extends TaskType = TaskType> {
  readonly type: T;
  execute(task: Task<T>): void;
}

export const TASK_ACTION_HANDLERS = new InjectionToken<TaskActionHandler[]>('TASK_ACTION_HANDLERS');
